<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="$router.go(-1)"
				src="../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Become Instructor
		</header>
		<BecomeInstructorForm />
	</div>
</template>

<script>
import BecomeInstructorForm from "@/components/BecomeInstructorForm.vue";
export default {
	components: {
		BecomeInstructorForm,
	},
};
</script>

<style></style>
